import React, { useState } from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import Dropdown from 'react-bootstrap/Dropdown';
import SitrepSectionWizard from './SitrepSectionWizard/SitrepSectionWizard';
import { useRemoveBulkSitrepSectionsV2 } from '../DisasterGPT/hooks/useSitrepsV2';

type EditReportProps = {
  onHide: () => void;
  sortedSitrepSections: {
    id: string;
    name: string;
  }[];
  sitrepId: string;
};

export const EditReportSidepanel: React.FC<EditReportProps> = ({
  onHide,
  sortedSitrepSections,
  sitrepId,
}) => {
  const [openSectionWizard, setOpenSectionWizard] = useState(false);
  const [data, setData] = useState(sortedSitrepSections);
  const [sectionsToDelete, setSectionsToDelete] = useState<string[]>([]);
  const removeSitrepSectionMutation = useRemoveBulkSitrepSectionsV2();

  const handleDelete = (sectionId: string) => {
    setData((prevData) =>
      prevData.filter((section) => section.id !== sectionId)
    );
    setSectionsToDelete((prev) => [...prev, sectionId]);
  };

  const handleSave = () => {
    if (sectionsToDelete.length === 0) {
      onHide();
      return;
    }
    removeSitrepSectionMutation.mutate({
      sitrepId: sitrepId,
      sectionIds: sectionsToDelete,
    });
    onHide();
  };

  return (
    (openSectionWizard && (
      <SitrepSectionWizard setIsEditingSitrepSections={setOpenSectionWizard} />
    )) || (
      <div className="sidebar p-3">
        <StylishNewButton
          className={'button button--link p-1 justify-content-end'}
          onClick={onHide}
        >
          <SharedIcon iconName="close" classes="text-white" />
        </StylishNewButton>
        <h4 className="d-flex justify-content-center m-0">Edit Report</h4>
        <hr />
        {data.map((section) => (
          <React.Fragment key={section.id}>
            <div className="edit-report-section-title">
              {section.name}
              <StylishNewButton
                className={'button button--link p-1'}
                onClick={() => handleDelete(section.id)}
              >
                <SharedIcon iconName="delete" classes="text-white" />
              </StylishNewButton>
            </div>
            <hr />
          </React.Fragment>
        ))}
        <div className="d-flex position-fixed bottom-0 end-0 p-3">
          <Dropdown>
            <Dropdown.Toggle
              as={StylishNewButton}
              className="button--secondary me-3 mb-2"
            >
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as="button" disabled={true} onClick={() => {}}>
                Create Incident
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => setOpenSectionWizard(true)}
              >
                Add Section
              </Dropdown.Item>
              <Dropdown.Item as="button" disabled={true} onClick={() => {}}>
                Download
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <StylishNewButton
            className={'button--primary mb-2'}
            onClick={handleSave}
          >
            {sectionsToDelete.length === 0 ? 'Close' : 'Save'}
          </StylishNewButton>
        </div>
      </div>
    )
  );
};
